<div *ngIf="loadingService.loading$ | async" class="cssload-container">
  <div>
    <img
      src="/assets/images/logos/loader-gif.svg"
      class="cssload-speeding-wheel"
      alt="loader"
    />
  </div>
</div>
